exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-tooltip[data-v-d07a12ce] {\n  z-index: 9999;\n}\n", ""]);

// exports
